import React from 'react';

const SavingsIcon = ({ fill, className }) => {
  return (
    <svg
      width='18'
      height='21'
      viewBox='0 0 18 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M10 12.1079L12.3 9.92779C12.7 9.54864 13.3 9.54864 13.7 9.92779C14.1 10.3069 14.1 10.8757 13.7 11.2548L9.7 15.0463C9.65 15.0937 9.6 15.1174 9.55 15.1411C9.5 15.1648 9.45 15.1885 9.4 15.2359C9.1 15.3307 8.8 15.3307 8.6 15.2359C8.5 15.2359 8.4 15.1411 8.3 15.0463L4.3 11.2548C3.9 10.8757 3.9 10.3069 4.3 9.92779C4.5 9.73821 4.7 9.64343 5 9.64343C5.3 9.64343 5.5 9.73821 5.7 9.92779L8 12.1079V1.11249C8 0.543765 8.4 0.164612 9 0.164612C9.6 0.164612 10 0.543765 10 1.11249V12.1079ZM18 17.7586V15.1628C18 14.6436 17.64 14.2975 17.1 14.2975C16.56 14.2975 16.2 14.6436 16.2 15.1628V17.7586C16.2 18.2778 15.84 18.6239 15.3 18.6239H2.7C2.16 18.6239 1.8 18.2778 1.8 17.7586V15.1628C1.8 14.6436 1.44 14.2975 0.9 14.2975C0.36 14.2975 0 14.6436 0 15.1628V17.7586C0 19.2296 1.17 20.3545 2.7 20.3545H15.3C16.83 20.3545 18 19.2296 18 17.7586Z'
        fill={fill}
      />
    </svg>
  );
};

export default SavingsIcon;
